import { ApiQueryParams } from '@frontend/api-utils';
import { IProduct } from '@frontend/product/types';
import { StockReplenishmentExtendedClient } from '@frontend/stock/api';
import { StockReplenishmentExtended } from '@frontend/stock/types';
import { ScreenTrigger, ScreenType } from '@frontend/wizard/types';
import { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { useAppSelector } from '../../../redux/store';
import { useScreen } from '../useScreen';

export const useReplenishOverview = () => {
    const intl = useIntl();
    const navigationState = useAppSelector((state) => state.navigation);
    const { store, updateWizardData, onSubmit: onContinue } = useScreen();
    const [replenishment, setReplenishment] = useState<StockReplenishmentExtended[]>([]);

    useEffect(() => {
        if (!navigationState.iot || !navigationState.iot.spot_id) return;

        onFetch();
    }, [navigationState.iot]);

    const onFetch = (queryParams?: ApiQueryParams<any>) => {
        if (!navigationState.iot || !navigationState.iot.spot_id) return;

        StockReplenishmentExtendedClient.fetchStockReplenishmentsExtended({
            account_id: navigationState.iot.account_id,
            spot_id: navigationState.iot.spot_id,
            sort_field: 'filled_min_percentage',
            sort_direction: 'asc',
            ...queryParams
        }).then((res) => {
            setReplenishment(res.results);
        });
    };

    const selectProduct = useCallback(
        (product: ReplenishmentWithProduct) => {
            updateWizardData({ selectedProduct: product });

            const nextStep = store?.steps.find((step) => step.screen === ScreenType.REFILL_OVERVIEW && step.trigger === ScreenTrigger.SUBMIT);
            onContinue(nextStep);
        },
        [store, updateWizardData, onContinue]
    );

    return {
        replenishment,
        selectProduct,
        intl,
        onFetch
    };
};

export interface ReplenishmentWithProduct extends Omit<StockReplenishmentExtended, 'product'> {
    product: IProduct;
}
